import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Modal } from "antd";
import React, { useState } from "react";
import axios from "axios";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
const ConsignmentWithdrawFromMarketModal = (props) => {
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const withdrawFromMarket = () => {
        setSaving(true);
        setErrorMessage(null);
        axios.delete(`/admin/v1/consignments/${props.consignment?.id}/marketplace`)
            .then(response => {
            setErrorMessage(null);
            props.onUpdated();
        })
            .catch(error => {
            if (isConcurrentModificationError(error)) {
                setErrorMessage("Could not withdraw consignment from marketplace. This is because another user has updated the same consignment.  Please refresh the consignment and try again.");
            }
            else {
                axiosErrorHandler(error, setErrorMessage);
            }
        })
            .finally(() => {
            setSaving(false);
        });
    };
    return (_jsxs(Modal, { title: "Withdraw from Market", open: props.open, okText: "Withdraw from Marketplace   ", onOk: withdrawFromMarket, onCancel: () => {
            setErrorMessage(null);
            props.onCancel();
        }, confirmLoading: saving, children: [_jsx("p", { children: "Are you sure you want to withdraw this consignment from the marketplace?" }), errorMessage &&
                _jsx("div", { style: { marginTop: "20px" }, children: _jsx(Alert, { type: "error", title: errorMessage, banner: true }) })] }));
};
export default ConsignmentWithdrawFromMarketModal;
